import { createRoutine } from 'redux-saga-routines';

export const fetchHouseholdMemberColumns = createRoutine(
  'FETCH_HOUSEHOLD_MEMBER_COLUMNS'
);
